import { render, staticRenderFns } from "./AttendeeRegAdd.vue?vue&type=template&id=1c2a24d4&"
import script from "./AttendeeRegAdd.vue?vue&type=script&lang=js&"
export * from "./AttendeeRegAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports